<small *ngIf="errorMessage !== undefined" class="errorMessage text-danger">
  {{ errorMessage }}
</small>